import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	token: "",
	data: null,
	fetch: false,
};

const userSlice = createSlice({
	name: "user",
	initialState: initialState,
	reducers: {
		set: (state, action) => {
			state.token = action.payload.token;
			localStorage.setItem("token", action.payload.token);
			state.data = action.payload.user;
			state.fetch = false;
		},
		get: (state) => {
			state.fetch = true;
		},
		drop: () => initialState,
	},
});

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;
